import {format} from 'date-fns'
import React from 'react'
import {Card} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Message} from '../types'

function ChatContentView({selectedChat}: {selectedChat: Message}) {
  return (
    <div
      style={{
        backgroundColor: '#F4F4F4',
        width: '60%',
        backgroundImage: `url('${toAbsoluteUrl('/media/stock/900x600/42.png')}')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      className="d-flex align-items-center justify-content-center h-100  overflow-auto "
    >
      <Card className="bg-white " style={{minWidth: '65%', maxWidth: '70%'}}>
        <Card.Body className="p-0">
          <div className="card-title p-6 border-bottom">
            <div className="d-flex align-items-center">
              <div
                className="d-flex justify-content-center align-items-center fw-light"
                style={{
                  width: '45px',
                  height: '45px',
                  borderRadius: '20%',
                  backgroundColor: '#B9F0FC',
                  fontSize: '20px',
                  color: '#6a6a6a',
                }}
              >
                A
              </div>
              <div className="ms-3">
                <div className="fs-4 fw-normal">Admin</div>
                <div className="small text-gray-700 fw-normal" style={{fontSize: '12px'}}>
                  {format(selectedChat.sentAt, 'dd/MM/yyyy, hh:mm aa')}
                </div>
              </div>
              <div className="ms-auto">
                <div className="">Message Type</div>
                <div className="text-capitalize text-gray-700">{selectedChat.messageType}</div>
              </div>
            </div>
          </div>
          <Card.Text className="p-6 pt-2 lead" style={{minHeight: '70px'}}>
            {selectedChat.content}
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  )
}

export default ChatContentView
